import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ReferenceTableService} from "../reference-table.service";
import {ActivatedRoute, Router} from "@angular/router";
import {GridOptions} from "ag-grid/main";
import {
  AgGridUtility,
  CommonUtility,
  DataService,
  DateUtility,
  DOUBLE_ROW_HEADER,
  ServerConstantsService,
  VIEW_BTN
} from "../shared";
import {NotificationsService} from "angular2-notifications";
import {HttpClient} from "@angular/common/http";
import {ContactHistory} from "../shared/model/contactHistory.model";
import {UserRolePagesMapping} from "../shared/model/user-role-pages-mapping.model";

@Component({
  selector: 'app-contact-history',
  templateUrl: './contact-history.component.html',
  styleUrls: ['./contact-history.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class ContactHistoryComponent implements OnInit {
  @ViewChild('headerText') headerText: ElementRef;

  ServerConstants: any;
  sharedData: any;
  refData: any;
  referralId: string = '';
  wpPersonId: string = '';


  userActionNotificationsMap: any;
  contactReasonCd: any;
  contactMethodCd: any;
  contactOutcomeCd: any;

  contactReasonMap: any;
  contactMethodMap: any;
  contactOutcomeMap: any;

  contactReasonJson: any;
  contactMethodCJson: any;
  contactOutcomeJson: any;

  contactsHistory: ContactHistory[];
  contact: ContactHistory;

  pageInfo: any;
  index: any;
  firstTime: Boolean = true;

  /*Grid Table*/
  columnDefs: any;
  context: any;
  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;
  gridOptions: GridOptions;
  gridApi: any;
  tabIndex: any = "-1";
  tabToNextCell: any;


  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              private router: Router,
              private commonUtil: CommonUtility,
              private dateUtil: DateUtility,
              private data: ReferenceTableService,
              public dataService: DataService,
              private notificationService: NotificationsService,
              private agGridUtility: AgGridUtility,
              private serverConstantsService: ServerConstantsService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if (this.dataService.getSharedDataObject().get('CNHIS') == undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.dataService.globalAccess = true;
    this.index = this.dataService.getSharedDataObject().get("CNHIS").innerNavPages.find(x => x.pageId === 'CNHSU');
    if (this.index.readOnly == true) {
      this.tabIndex = "0";
    }
    this.sharedData = this.dataService.getSharedDataObject();

    this.parseRefTableData();

    this.contact = new ContactHistory();
    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId');

    this.contact.wpPersonId = parseInt(this.wpPersonId);
    this.getColumnDefinitions();
    this.contactsHistory = [];

    this.load();
  }

  load() {
    this.http.post<ContactHistory[]>(this.ServerConstants.SERVER_API_URL + "/contact/load", this.contact).subscribe(
      (data: ContactHistory[]) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Contact History', this.userActionNotificationsMap.ERROR);
        }
        else {
          this.contactsHistory = data;
        }
      },
      response => {
        this.notificationService.error('Contact History', this.userActionNotificationsMap.ERROR);
      },
      () => {
      });

  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
    /*setTimeout(()=>{
      const element = window.document.querySelectorAll("div[role=gridcell]")[54];
      console.log(element);
      element.addEventListener("keydown", function(e : KeyboardEvent ) {
        if(e.key === "Tab"){
          e.preventDefault();
          window.document.querySelectorAll("h1")[0].focus();
          window.document.querySelectorAll("h1")[0].click();
        }
      })
    },1000)*/
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else {
      this.gridOptions.api.sizeColumnsToFit();
    }
  }


  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Contact Date',
        field: 'contactDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates,
        },
      },
      {
        headerName: 'Contact Method',
        field: "contactMethodCd",
        refData: this.contactMethodCJson,
        cellStyle: {'white-space': 'normal'},
      },
      {
        headerName: 'Contact Reason',
        field: "contactReasonCd",
        refData: this.contactReasonJson
      },
      {
        headerName: 'Contacted By',
        field: 'contactedBy',
        cellStyle: {'white-space': 'normal'},
      },
      {
        headerName: 'Contact Outcome',
        field: 'contactOutcomeCd',
        refData: this.contactOutcomeJson
      },
      {
        headerName: 'Notes',
        field: 'notes',
        cellStyle: {'white-space': 'normal'},
        tooltipField: 'notes'
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        suppressFilter: true,
        suppressSorting: true
      },
    ];

    this.context = {
      component: this,
    };

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  getEditButton(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    const image = VIEW_BTN;
    element.innerHTML = image;

    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('contact-history', params.data);
      that.router.navigate(['task/contactSummary/contactDetails']);
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('contact-history', params.data);
        that.router.navigate(['task/contactSummary/contactDetails']);
      }
      /*else if((!event.shiftKey && event.keyCode==9) && (params.rowIndex == (that.contactsHistory.length -1))){
        event.preventDefault();
        setTimeout(() => that.header.nativeElement.focus(), 0);
        that.header.nativeElement.click();
      }*/

    });
    element.setAttribute("tabindex", "0");
    return element;
  }

  convertCode(myMap, code) {
    if (myMap != undefined) {
      return myMap.get(code);
    }
  }

  loadContactDetails() {
    this.dataService.removeValueFromSharedDataMap('contact-history');
    this.router.navigate(['task/contactSummary/contactDetails']);
  }

  parseRefTableData() {

    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
    this.contactReasonCd = this.data.getValueFromSharedDataMap("ContactReason");
    this.contactMethodCd = this.data.getValueFromSharedDataMap("ContactMethod");
    this.contactOutcomeCd = this.data.getValueFromSharedDataMap("ContactOutcome");

    this.contactReasonMap = this.commonUtil.createMapFromList(this.contactReasonCd);
    this.contactMethodMap = this.commonUtil.createMapFromList(this.contactMethodCd);
    this.contactOutcomeMap = this.commonUtil.createMapFromList(this.contactOutcomeCd);

    this.contactReasonJson = this.commonUtil.createNativeMapFromList(this.contactReasonCd);
    this.contactMethodCJson = this.commonUtil.createNativeMapFromList(this.contactMethodCd);
    this.contactOutcomeJson = this.commonUtil.createNativeMapFromList(this.contactOutcomeCd);
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  focusSummary(e) {
    this.firstTime = false;
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event) {
    const tabKeyCode = 9;

    // ignore non tab key strokes
    if (event.keyCode !== tabKeyCode) {
      return;
    }

    if (this.contactsHistory.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);
    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');
    // scrolls to the first column
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);
    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
  filter(event){
    this.firstTime = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/contact-history/contact-history.component.ts